module.exports = __webpack_public_path__ + "mainassets/img/helpform2.112acc85.svg";